export default "Cradle\nMars\nVenus\nMercury\nKarrakis\nSparr\nRas Shamra\nCarina\nAun'ist\nHercynia\nHavelburg\nKibo\nCressidium\nTó Neinilii";